import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import './ConfigCompany.css'; // Importeer de bijbehorende CSS
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_LeaveCompany from './Icon Leave Company.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_ConfigCompany from './Icon Config Company.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import api from './axios'


const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


function ConfigCompany() {
    const { user, updateUser, companyId, switchCompany, companyName, logout } = useAuth();
    const [menu2Open, setMenu2Open] = useState(false);
    const menu2Ref = useRef(null);
    const navigate = useNavigate(); 
    const [activeMenu, setActiveMenu] = useState('companyInfo');  // Standaard is 'Company Info' actief
    const [companyReports, setCompanyReports] = useState([]);
    const [companyUsers, setCompanyUsers] = useState([]);
    const [companyLicenses, setCompanyLicenses] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [showQuestionYesNoPopup, setShowQuestionYesNoPopup] = useState(false);
    const [showQuestionYesNoPopup_TerminateLicense, setShowQuestionYesNoPopup_TerminateLicense] = useState(false);
    const [confirmLeave, setConfirmLeave] = useState(null);
    const [showInvitePopup, setShowInvitePopup] = useState(false);
    const [NewUserEmail, setNewUserEmail] = useState(null);
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [messagePopup, setMessagePopup] = useState('');
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [invitationMessage, setInvitationMessage] = useState('');
    const [accessRole, setAccessRole] = useState('Viewer'); // Standaardwaarde
    const [selectedRoleId, setSelectedRoleId] = useState(3); // Standaardwaarde overeenkomstig met 'Viewer'
    const [userRoles, setUserRoles] = useState(companyUsers.map(user => user.user_companies_roleDescription));
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [dataVersion, setDataVersion] = useState(0);
    const [selectedCategory, setSelectedCategory] = useState('Support');
    const [Request_message, setRequestMessage] = useState("");
    const [showHelpPopup, setShowHelpPopup] = useState(false);
    const [selectedLicenseId, setSelectedLicenseId] = useState('');
    const [newCompanyName, setNewCompanyName] = useState('');  
    const [showPopup_CompanyName, setShowPopup_CompanyName] = useState(false);
    const fileInputRef = useRef(null);
    const [logoPath, setLogoPath] = useState(null);
    const fileExtensions = ["png", "jpg", "jpeg", "gif", "bmp"]; // Voeg hier meer extensies toe indien nodig
  

    useEffect(() => {
        (async () => {
          if (!companyId) {
            setLogoPath(null);
            return;
          }
      
          let found = false;
          for (const ext of fileExtensions) {
            const timestamp = Date.now(); // Voeg een tijdstempel toe om de cache te omzeilen
            const path = `/Media/Company Logos/Logo-${companyId}.${ext}?t=${timestamp}`;
            try {
              const response = await fetch(path);
      
              if (response.status === 200 && response.headers.get('Content-Type').includes('image')) {
                // Afbeelding bestaat
                setLogoPath(path);
                found = true;
                break;
              }
            } catch (error) {
              console.log("Error loading image:", error);
            }
          }
          if (!found) {
            setLogoPath(null);
          }
        })();
      }, [companyId]);


      const updateCompanyName = async () => {        
        if (companyName !== newCompanyName) {
          try {
            // call through your axios-instance (withCredentials → auto‐cookies)
            const { data } = await api.post('/api/updateCompanyName', {
              company_id: companyId,
              new_company_name: newCompanyName
            })
      
            // if backend reports success
            if (data.success) {
              // close popup
              setShowPopup_CompanyName(false)
      
              // update context + local component state
              updateUser({ default_companyname: newCompanyName });
              switchCompany(companyId, newCompanyName);
      
              setMessage('Company name updated successfully!');
              setShowPopupMessage(true)
              setTimeout(() => setShowPopupMessage(false), 3000)
            }
          } catch (err) {
            // handle 401 → session expired
            if (err.response?.status === 401) {
              await logout()
              setError('Session expired')
              setShowErrorPopup(true)
              setTimeout(() => setShowErrorPopup(false), 3000)
              navigate(`/login/${companyId}`)
              return
            }
            console.error('Update company name failed:', err)
            setError(err.response?.data?.error || err.message)
            setShowErrorPopup(true)
            setTimeout(() => setShowErrorPopup(false), 3000)
          }
        } else {
          setShowPopup_CompanyName(false)
        }
      }

      const handleSendHelpButton = async (event) => {
        event.preventDefault();
        setShowHelpPopup(false);
      
        try {
          const { data } = await api.post('/api/requestforsupport/', {
            user_id:          user.id,
            user_email:       user.email,
            user_name:        user.name,
            company_id:       companyId,
            company_name:     companyName,
            Request_category: selectedCategory,
            Request_message:  Request_message,
            currentURL:       window.location.href
          });
      
          // Succes
          setMessage('Request for support sent successfully');
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
        } catch (err) {
          // 401 → token verlopen
          if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return;
          }
      
          // andere fout
          setError(err.response?.data?.error || err.message);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      };

    const handleMyProfile = () => {
        navigate('/my-profile');
      };

    // binnen je ConfigCompany component
    const deleteUserFromCompany = async (targetUserId) => {
        try {
        // haal user en companyId uit de context
        const { id: meId, default_companyid } = user;
        
        // DELETE via axios-instance; body meegeven via `data`
        const { data } = await api.delete('/api/deleteuserfromcompany', {
            data: {
            userId: targetUserId,
            companyId
            }
        });
    
        if (data.userDeleted && data.companyDeleted) {
            setMessage('User and company deleted');
            setShowPopupMessage(true);
            setTimeout(() => setShowPopupMessage(false), 3000);
    
            // als mijn default company verwijderd is, clear context
            if (default_companyid === companyId) {
            updateUser({ default_companyid: null });
            switchCompany(null, null);
            }
    
            navigate('/main');
            return;
        }
    
        if (data.userDeleted) {
            setMessage('User left company successfully');
            setShowPopupMessage(true);
            setTimeout(() => setShowPopupMessage(false), 3000);
        }
    
        // refresh users list
        setDataVersion(v => v + 1);
    
        } catch (err) {
        // 401 → session expired
        if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return;
        }
    
        console.error('Error leaving user from company:', err);
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        }
    };
      
    const handleRemoveUserClick = (userId) => {
        // Hier voeg je de logica toe om te controleren of de te verwijderen gebruiker de enige admin is
        const admins = companyUsers.filter(user => user.user_companies_roleDescription === 'Admin');
        setSelectedUserId(userId);

        if (admins.length === 1 && admins[0].id === userId && companyUsers.length > 1) {
            setError("This user is the only admin and there are multiple users. You cannot remove the only admin.");
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 
        } else {
            if (companyUsers.length === 1) {
                setMessagePopup('Are you sure you want to leave the last user from the company? This will delete the company and all of the reports as well!')
                setShowQuestionYesNoPopup(true);
            } else {
                setMessagePopup('Are you sure you want to leave the user from the company?')
                setShowQuestionYesNoPopup(true);
            }
        }
    }
      
    
    const countAdmins = (roles) => {
        return roles.filter(role => role === 'Admin').length;
    };
    
    
    const handleRoleChange = async (index, userId, newRole) => {
        const currentRoles = [...userRoles];
        currentRoles[index] = newRole;

        if (newRole !== 'Admin' && countAdmins(currentRoles) < 1) {
            // Toon een foutmelding dat er ten minste één admin moet zijn
            setError('At least 1 user must have an admin role');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 

            return;
        }

        const updatedUser = await updateUserRole(userId, newRole);
        if (updatedUser) {
            setUserRoles(currentRoles);
        }
    };

    const InviteUser_handleRoleChange = (event) => {
        const selectedRoleName = event.target.value;
        const selectedRoleId = roleToIdMapping[selectedRoleName];
        // Nu kun je de state bijwerken of wat je ook nodig hebt met selectedRoleId
        setAccessRole(selectedRoleName); // Als je de naam van de rol ook in de state wilt opslaan
        setSelectedRoleId(selectedRoleId); // Stel de state in met de ID van de geselecteerde rol
    };
    
    // Mapping van rollen naar roleIDs
    const roleToIdMapping = {
      'Viewer': 3,
      'Member': 2,
      'Admin': 1
    };
    
    const emailIsValid = (email) => {
        // Eenvoudige regex voor basis e-mailvalidatie
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
      };

    
    const handleInviteUser = () => {
        // Reset de staat van de user email om het invulveld leeg te maken
        setShowInvitePopup(true);
        setNewUserEmail("");
    };

    const updateUserRole = async (userCompanyId, roleString) => {
        try {
          // converteer de rol-naam naar het bijbehorende ID
          const roleId = roleToIdMapping[roleString];
      
          // roep de backend aan via je axios-instance
          const { data } = await api.post('/api/updateUserRole', {
            userCompanyId,
            roleId
          });
      
          // bij succes toon een melding
          setMessage('Company role successfully updated');
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
          // retourneer de response data zodat caller weet wat er is gebeurd
          return data;
        } catch (err) {
          // 401 → sessie verlopen, log de gebruiker uit
          if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return null;
          }
      
          // andere fouten: log en toon popup
          console.error('Error updating company role:', err);
          const msg = err.response?.data?.error || err.message;
          setError(`Error updating company role: ${msg}`);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
      
          return null;
        }
      };      

      const handleSendInviteButton = async (event) => {
        event.preventDefault();
        setShowInvitePopup(false);
      
        try {
          // verstuur uitnodiging via je axios-instance
          const { data } = await api.post('/api/send-invite', {
            email:               NewUserEmail,
            invitationmessage:   invitationMessage,
            roleId:              selectedRoleId,
            invitedByUserId:     user.id,
            invitedToCompanyId:  companyId,
          });
      
          // bij succes
          setMessage(`Invitation e-mail successfully sent to ${NewUserEmail}`);
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
        } catch (err) {
          // 401 → sessie verlopen
          if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return;
          }
      
          // andere fouten
          const msg = err.response?.data?.error || err.message;
          setError(`Error sending invitation mail: ${msg}`);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      };
      
      const handleLogout = async () => {
        try {
          // Roept de logout-functie uit je AuthContext aan, die server-side de sessie beëindigt en de context leegt
          await logout();
        } catch (err) {
          console.error('Logout failed:', err);
          // eventueel kun je hier een fallback tonen, maar doorgaans mag je gewoon doorgaan
        }
        // Navigeer naar de login-pagina voor de huidige company
        navigate(`/login/${companyId}`);
      };
      
      const handleSwitchCompany = () => {
        navigate('/my-companies');
      };

      
      const handleClickOutside = (event) => {
        if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
          setMenu2Open(false);
        }
      };

      const handleMenu_Help = () => {
        setShowHelpPopup(true);
      };
    
      useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        // Opruimen bij ontkoppeling
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []); // Geen afhankelijkheden, alleen bij mounten en ontkoppelen


      useEffect(() => {
        if (!user || !companyId) return;
      
        const fetchData = async () => {
          try {
            // POST in plaats van GET, waarbij we user.id en companyId in de body meegeven
            const { data } = await api.post(
              '/api/getcompanyuserscompanyreports',
              { userId: user.id, companyId }
            );
      
            // Zet de response in state
            setCompanyUsers(data.companyUsers || []);
            setUserRoles(
                (data.companyUsers || []).map(u => u.user_companies_roleDescription)
              );
            setCompanyReports(data.companyReports || []);
            setUserRole(data.roleId ?? 3);
      
            // Update naam in context als backend die terugstuurt
            if (data.companyName) {
              switchCompany(companyId, data.companyName);
            }
      
            setCompanyLicenses(data.companyLicenses || []);
          } catch (err) {
            console.error('Error fetching company data:', err);
            // 401 afvangen via interceptor / fallback
            if (err.response?.status === 401) {
              await logout();
              setError('Session expired');
              setShowErrorPopup(true);
              setTimeout(() => setShowErrorPopup(false), 3000);
              navigate(`/login/${companyId}`);
            } else {
              setError(err.response?.data?.error || err.message);
              setShowErrorPopup(true);
              setTimeout(() => setShowErrorPopup(false), 3000);
            }
          }
        };
      
        fetchData();
      }, [dataVersion, companyId, user, logout, switchCompany, navigate]);      
      
      
    useEffect(() => {
        if (confirmLeave === true) {
            // De gebruiker heeft op "Yes" geklikt, voer de gewenste actie uit
            // Bijvoorbeeld: het verlaten van het bedrijf, etc.
            // Code om het bedrijf te verlaten

            
        } else if (confirmLeave === false) {
            // De gebruiker heeft op "No" geklikt, je kunt hier eventueel aanvullende acties uitvoeren
        }
        // Reset confirmLeave naar de oorspronkelijke staat na het verwerken
        setConfirmLeave(null);
      }, [confirmLeave]);

    useEffect(() => {
        if (activeMenu === 'reports') {
            // Voorbeeld API-aanroep met fetch:

        }
    }, [activeMenu]);

            
    // Toon 'access denied' de pagina als de gebruiker geen Admin (1) of Member (2) is
    if (!user || (user.company_roleId !== 1 && user.company_roleId !== 2)) {
        return "Access denied";
    }

    function handleDetailsReport(reportId) {
        // Voer hier de actie uit die je wilt doen met het betreffende report
        navigate(`/configcompanyreport/${reportId}`);
    }

    const TerminateLicense = async () => {
        try {
            // Bouw de payload op vanuit context (geen localStorage meer)
            const payload = {
            licenseId: selectedLicenseId,
            terminatedByUserId: user.id,
            companyId
            };
        
            // Roep de API aan via je axios-instance (incl. cookies & interceptor)
            await api.post('/api/terminateLicense/', payload);
        
            // Succes-melding
            setMessage('Request for license termination sent');
            setShowPopupMessage(true);
            setTimeout(() => setShowPopupMessage(false), 3000);
        
        } catch (err) {
            // 401 via interceptor mogelijk al afgehandeld, maar hier alsnog:
            if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return;
            }
        
            // Algemene fout afhandelen
            setError(err.response?.data?.error || err.message);
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
        }
    };

    function formatDate(dateString) {
        const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('nl-NL', options);
    }

      // Als de gebruiker niet is ingelogd, render dan niets
    if (!user || userRole == 3 || companyId === null)    // 3 = Viewer role
    {
        return null;
    }
      
    const handleFileUpload = async (file) => {
        // companyId komt uit context, niet uit localStorage
        const compId = companyId;
        const fileExtension = file.name.split('.').pop();
      
        try {
          // 1) Presigned URL ophalen
          const presignedRes = await api.post('/generate-presigned-url', {
            company_id: compId,
            file_extension: fileExtension
          });
          const { url } = presignedRes.data;
      
          // 2) Upload naar S3
          const uploadRes = await fetch(url, {
            method: 'PUT',
            body: file
          });
          if (!uploadRes.ok) throw new Error('Failed to upload file to S3');
      
          // 3) Backup-logo naar eigen server (geen auth-header)
          const formData = new FormData();
          formData.append('file', file);
          formData.append('company_id', compId);
          await fetch('/api/uploadCompanyLogo', {
            method: 'POST',
            body: formData
          });
      
          // Feedback aan gebruiker
          setMessage('Company logo uploaded successfully');
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
        } catch (err) {
          console.error('Failed to upload company logo:', err);
          setError('Failed to upload company logo: ' + err.message);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        
        if (!file) {
            return;
        }
        
        // Check de bestandsgrootte (max 1MB = 1024 * 1024 bytes)
        if (file.size > 1024 * 1024) {
            alert("Filesize too large. Choose filesize less then 1MB.");
            return;
        }
        
        // Check het bestandstype (bijvoorbeeld alleen afbeeldingen)
        if (!file.type.match('image.*')) {
            alert("Please choose a valid image file.");
            return;
        }
        
        // Na validatie, upload het bestand
        handleFileUpload(file);

        // Reset de input waarde
        event.target.value = '';
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };


  return (
    <CSSTransition
      in={true} // Deze waarde verandert wanneer je navigeert
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
    <div className="page">

        <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <button className="back-button" onClick={() => navigate(-1)}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
            <div className="configCompanies-title">Config company '{companyName}'</div>

            <div style={{ position: 'relative' }}>
            <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
            <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
            {menu2Open && (
                <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                    {companyName || 'No company assigned'}
                    {
                        user?.company_roleId && user?.company_roleId <= 2 && companyName && (
                        <a href={`/configcompany/${companyId}`}>
                            <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                        </a>
                        )
                    }
                </div>             
                <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
                <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
                <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                </div>
            )}
            </div>
        </div>
        </header>

        <div className="sidebar-cc">
            <div className="menu-item-cc" onClick={() => setActiveMenu('companyInfo')}>
                <span className={activeMenu === 'companyInfo' ? 'active' : ''}>Company info</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('users')}>
                <span className={activeMenu === 'users' ? 'active' : ''}>Manage users</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('reports')}>
                <span className={activeMenu === 'reports' ? 'active' : ''}>Manage reports</span>
            </div>
            {userRole === 1 && (
            <div className="menu-item-cc" onClick={() => setActiveMenu('licenses')}>
                <span className={activeMenu === 'licenses' ? 'active' : ''}>Manage licenses</span>
            </div>
            )}
        </div>

        <div className="content-cc">
            {activeMenu === 'companyInfo' && (
                <div className="report-table-container-cc">
                    <h3>Company Info</h3>

                    <div style={{height: '20px'}}></div>
                    <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '850px'}}>
                        <tbody>
                            <tr style={{ borderBottom: '1px solid lightgrey' }}> {/* Voeg een borderBottom toe aan deze rij */}
                                <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '350px' }}>
                                    Company name
                                </td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                                    {companyName}
                                </td>
                                <td className="details-cell" style={{ width: '125px' }}>
                                    {user?.company_roleId && user?.company_roleId <= 2 && (
                                        <button 
                                            className="details-button" 
                                            style={{ width: '125px' }} 
                                            onClick={() => { 
                                                setNewCompanyName(companyName); 
                                                setShowPopup_CompanyName(true); 
                                            }}
                                        >
                                            Edit
                                        </button>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ verticalAlign: 'top', textAlign: 'left', width: '350px' }}>
                                    Company logo
                                </td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '550px', fontWeight: 'bold' }}>
                                    {logoPath && (
                                        <img src={logoPath} alt="Company logo" style={{ maxHeight: '7vh', marginLeft: '0px', marginRight: '3px', marginTop: '3px', marginBottom: '3px' }} />                                    
                                    )}
                                </td>
                                <td className="details-cell" style={{ width: '125px' }}>
                                    {user?.company_roleId && user?.company_roleId <= 2 && (
                                        <div>
                                            <input 
                                                type="file"
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                                onChange={handleFileSelect}
                                            />
                                            <button 
                                                className="details-button" 
                                                style={{ width: '125px' }}
                                                onClick={handleClick}
                                            >
                                                Upload file
                                            </button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            {activeMenu === 'reports' && (
                <div className="report-table-container-cc">
                    <h3>Company Reports</h3>

                    {/* Tabel voor de koppen */}
                    <table className="report-table-1">
                        <thead>
                            <tr>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Report name</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>Keywords</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{/*Company owner*/}</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '150px' }}>Visible users</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '150px' }}>Licensed users</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}></th>
                            </tr>
                        </thead>
                    </table>

                    {/* Scrollbare div rond de tabel met de rijen */}
                    <div className="scrollable-table-container-cc">
                        <table className="report-table-2-cc">
                            <tbody>
                                {companyReports.map(report => (
                                    <tr key={report.id}>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report.name}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{report.keywords}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{/*{report.owner_company_name}*/}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '150px' }}>{report.visible_user_count}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '150px' }}>{report.active_user_count}</td>
                                        
                                        <td className="details-cell" style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>
                                            { userRole !== 3 && 
                                                <button className="details-button" onClick={() => handleDetailsReport(report.id)}>Details</button>
                                            }
                                        </td>
                                        
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            
            {activeMenu === 'users' && (
                <div className="report-table-container-cc">
                    <h3>Company Users</h3>

                    { userRole !== 3 && 
                        <div>
                            <div style={{ height: '20px' }}></div>
                            <button className="invite-user-button" onClick={handleInviteUser}>
                                + Invite user
                            </button>
                        </div>
                    }
                    <div style={{ height: '20px' }}></div>
                    {/* Tabel voor de koppen */}
                    <table className="report-table-1">
                        <thead>
                            <tr>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>User name</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>E-mail</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Company role</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}></th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}></th>
                            </tr>
                        </thead>
                    </table>

                    {/* Scrollbare div rond de tabel met de rijen */}
                    <div className="scrollable-table-container-cc">
                    <table className="report-table-2-cc">
                        <tbody>
                            {companyUsers.map((user, index) => (
                                <tr key={user.id}>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{user.name}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{user.email}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>
                                    {userRole === 1 ? (
                                        <select 
                                            value={userRoles[index]}
                                            onChange={e => handleRoleChange(index, user.id, e.target.value)}
                                            disabled={
                                            ['Customer Portal User', 'Employee Portal User', 'Supplier Portal User']
                                                .includes(user.user_companies_roleDescription)
                                            }
                                            style={{ width: '150px' }}
                                        >
                                            {['Customer Portal User', 'Employee Portal User', 'Supplier Portal User']
                                            .includes(user.user_companies_roleDescription) && (
                                                <option value={user.user_companies_roleDescription}>
                                                {user.user_companies_roleDescription}
                                                </option>
                                            )}
                                            <option value="Viewer">Viewer</option>
                                            <option value="Member">Member</option>
                                            <option value="Admin">Admin</option>
                                        </select>
                                        ) : (
                                        user.user_companies_roleDescription
                                        )}
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}></td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>
                                    { userRole !== 3 &&
                                        <img 
                                        src={icon_LeaveCompany} 
                                        alt="Icoon" 
                                        style={{cursor: 'pointer', width: '20px'}} 
                                        title="Leave user from company"
                                        onClick={() => handleRemoveUserClick(user.user_id)}  // Hier roep je de nieuwe functie aan
                                        />
                                    }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
            )}

            {activeMenu === 'licenses' && (
                <div className="report-table-container-cc">
                    <h3>License overview</h3>

                    {/* Tabel voor de koppen */}
                    <table className="report-table-1">
                        <thead>
                            <tr>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '175px' }}>Report name</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>License created</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '175px' }}>Created by</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>Expires on</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>Active users</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>Max. users</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>Price</th>
                                <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}></th>
                            </tr>
                        </thead>
                    </table>

                    {/* Scrollbare div rond de tabel met de rijen */}
                    <div className="scrollable-table-container-cc">
                        <table className="report-table-2-cc">
                            <tbody>
                                {companyLicenses.map(license => (
                                    <tr key={license.id}>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '175px' }}>{license.reportName}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{formatDate(license.datetime_created)}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '175px' }}>{license.createdByUserName}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>{formatDate(license.license_untill)}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>{license.activeUserCount}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '125px' }}>{license.max_number_licenseusers}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>€ {license.price} / {license.price_per}</td>
                                        
                                        <td className="details-cell" style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>
                                            <button className="details-button" style={{ fontSize: '14px', color: 'lightcoral' }} onClick={() => {setSelectedLicenseId(license.id); setShowQuestionYesNoPopup_TerminateLicense(true);}}>Terminate</button>
                                        </td>
                                        
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

        </div>

        {showQuestionYesNoPopup_TerminateLicense && (
        <div className="popup-container">
            <div className="popup-content">
            <h3 style={{ fontWeight: 'normal' }}>Are you sure you want to terminate this license?</h3>
            <div className="white-space"></div>
                <div className="buttons-container">
                    <button onClick={() => {
                        setShowQuestionYesNoPopup_TerminateLicense(false);
                        TerminateLicense();  // Voer de functie uit
                        }} style={{ color: 'black', fontWeight: 'bold' }}>
                        Terminate
                    </button>
                    <button onClick={() => {
                        setShowQuestionYesNoPopup_TerminateLicense(false);
                        }} style={{ color: 'black', fontWeight: 'bold' }}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
        )}

        {showQuestionYesNoPopup && (
        <div className="popup-container">
            <div className="popup-content">
            <h3 style={{ fontWeight: 'normal' }}>{messagePopup}</h3>
            <div className="white-space"></div>
                <div className="buttons-container">
                    <button onClick={() => {
                        setConfirmLeave(true);
                        setShowQuestionYesNoPopup(false);
                        deleteUserFromCompany(selectedUserId);  // Voer de functie uit
                        }} style={{ color: 'black', fontWeight: 'bold' }}>
                        Yes
                    </button>
                    <button onClick={() => {
                        setConfirmLeave(false);
                        setShowQuestionYesNoPopup(false);
                        }} style={{ color: 'black', fontWeight: 'bold' }}>
                        No
                    </button>
                </div>
            </div>
        </div>
        )}

        {showInvitePopup && (
            <div className="popup-container">
                <div className="popup-content">
                <h2 style={{ fontWeight: 'normal' }}>Invite user</h2>
                <div className="white-space"></div>
                <input
                    type="text"
                    placeholder="User email*"
                    className="company-name-input"
                    value={NewUserEmail}
                    onChange={(e) => setNewUserEmail(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Invitation message"
                    className="company-name-input"
                    value={invitationMessage}
                    onChange={(e) => setInvitationMessage(e.target.value)}
                />
                <div style={{ display: 'inline-block', marginRight: '10px' }}>
                    <div style={{ height: '20px', display: 'inline-block', fontSize: '14px', marginRight: '10px' }}>Company role:</div>
                    <select 
                        style={{ display: 'inline-block', width: '150px' }}
                        value={accessRole}
                        onChange={InviteUser_handleRoleChange}
                    >
                        {Object.keys(roleToIdMapping).map(roleName => (
                            <option key={roleName} value={roleName}>{roleName}</option>
                        ))}
                    </select>
                </div>
                <div style={{ height: '50px' }}></div>
                <div className="buttons-container">
                    <button onClick={() => setShowInvitePopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                        Cancel
                    </button>
                    <button
                    disabled={!emailIsValid(NewUserEmail)}
                    style={{
                        color: emailIsValid(NewUserEmail) ? 'black' : 'grey',
                        fontWeight: emailIsValid(NewUserEmail) ? 'bold' : 'normal',
                    }}
                    onClick={handleSendInviteButton}
                    >
                    Send invite
                    </button>
                </div>
                </div>
            </div>
        )}

        {showHelpPopup && (
            <div className="popup-container">
                <div className="popup-content">
                <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
                <div className="white-space"></div>
                <b>From:</b>
                <input
                    type="text"
                    placeholder="Username"
                    className="company-name-input"
                    disabled="true"
                    value={user.name || ""}
                />
                <b>Company:</b>
                <input
                    type="text"
                    placeholder="Company name"
                    className="company-name-input"
                    disabled="true"
                    value={companyName || ""}
                />
                <div style={{ display: 'inline-block', marginRight: '10px' }}>
                    <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                    <select 
                    style={{ display: 'inline-block', width: '150px' }}
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                >
                    <option value="Support">Support</option>
                    <option value="Customization request">Customization request</option>
                </select>
                </div>
                <div className="white-space"></div>
                <div className="white-space"></div>
                <b>Message:</b>
                <div className="white-space"></div>
                <textarea
                    placeholder="Request for support message"
                    className="company-name-input"
                    rows="4"
                    value={Request_message}
                    style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                    onChange={(e) => setRequestMessage(e.target.value)}
                ></textarea>
                <div style={{ height: '50px' }}></div>
                <div className="buttons-container">
                    <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                        Cancel
                    </button>
                    <button
                    onClick={handleSendHelpButton}
                    style={{ color: 'black', fontWeight: 'bold' }}
                    >
                    Send request
                    </button>
                </div>
                </div>
            </div>
        )}

        {showPopup_CompanyName && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Edit company name</h2>
            <div className="white-space"></div>
            <input
                type="text"
                placeholder="Full name *"
                className="company-name-input"
                value={newCompanyName}
                onChange={(e) => setNewCompanyName(e.target.value)}
            />
            <div className="buttons-container">
                <button onClick={() => setShowPopup_CompanyName(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
                <button
                    disabled={!newCompanyName}
                    style={{ color: newCompanyName ? 'black' : 'grey', fontWeight: newCompanyName ? 'bold' : 'normal' }}
                    onClick={() => updateCompanyName()}
                >
                    Confirm
                </button>
            </div>
          </div>
        </div>
        )}

        {showPopupMessage && <div className="popup-message">{message}</div>}
        {showErrorPopup && <div className="popup">{error}</div>}
    </div>
    </CSSTransition>
  );
}

export default ConfigCompany;